import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  pagination: {
    '& .MuiPaginationItem-root': {
      margin: 0
    },
    '& .MuiPagination-ul li:first-child button': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 0
    },
    '& .MuiPagination-ul li:last-child button': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 0
    },
    '& .MuiPagination-ul li:not(:last-child):not(:first-child) button': {
      borderRadius: 0
    }
  },
  wlTable: {
    backgroundColor: 'white',
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`,
    overflow: 'hidden'
  },
  filterTabs: {
    padding: '12px 16px',
    borderBottom: `1px solid ${GRAY_COLORS[200]}`
  },
  tableStatusBtn: {
    padding: '8px 12px',
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[500]
  },
  tableStatusBtnActive: {
    color: `${PRIMARY_COLORS[700]} !important`,
    backgroundColor: `${PRIMARY_COLORS[50]} !important`
  },
  tableStatusCount: {
    display: 'flex',
    height: 22,
    borderRadius: 16,
    padding: '2px 8px',
    fontSize: 12,
    fontWeight: 500,
    color: PRIMARY_COLORS[700],
    backgroundColor: PRIMARY_COLORS[100]
  },
  customizedCheckbox: {
    padding: '4px 10px 4px 5px',
    border: `1px solid ${GRAY_COLORS[300]}`,
    borderRadius: 6,
    fontSize: 14,
    '& .MuiCheckbox-root': {
      padding: 0,
      marginRight: 6
    }
  },
  discountTabs: {
    '& .Mui-selected': {
      color: PRIMARY_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: PRIMARY_COLORS[700]
    }
  }
}))
